<template>
  <div class="blog-post">

    <div class="modal-header">
      <button type="button" class="close" data-dismiss="modal">&times;</button>
      <h3 class="modal-title">The Start of Bootcamp</h3>
      <h5 class="date">September 23, 2017</h5>
    </div>
    <div class="modal-body">
      <p>
      Joining a bootcamp for web development has been something I've thought about
      in the past and, somehow, just never really got around to looking into, let
      alone applying for. That all changed about 3 months ago. I had recently moved
      back to Central Kentucky after about a year of work in the automotive
      industry in Nasville, TN and to say I was glad to be home would be the
      understatement of a lifetime. Little did I know just how quickly things
      would progress once I stumbled upon the Awesome Inc website randomly one day.
      </p>
      <p>

      The application process was <i>extremely</i> thorough, consisting of multiple
      challenges (some beginner coding related, others more of a thought
      process exercise) that had to be completed for a chance at acceptance
      into the program. I had already completed my application process the
      day of the open house available to the public about 2 months prior
      to the planned start date of the bootcamp, and had scheduled my interview
      for that same day.
      </p>

      <p>
        
      The interview was actually really fun. It was set up just like any job
      interview I've ever been to, but the questions asked got a little more
      personal than in my previous experiences. It seemed the team at Awesome
      Inc University didn't just want capable students, they were also looking
      for individuals that wanted to make a difference. Besides the questions
      there was also a technical portion which involved playing a game on a
      tablet called Lightbot. It seemed strange to me at first until I realized
      that the game relies on you to interperet the landscape, plan accordingly
      and then execute your moves to be successful, an ability I have come to
      realize is extremely important for bootcamp. I was confident, but with 
      only 10-15 people being selected for the program, I was extremely humble 
      about my chances of actually getting in.
      </p>

      <p>

      Congratulations! That was the first word of the email I received roughly a month
      before the bootcamp start date. I remember opening the email and being too afraid
      to actually scroll down to see what was written for at least 5 minutes. 
      The next month consisted of completing pre-work challenges, watching video
      content, and generally familiarizing myself with some of the more commonly used
      current technologies associated with web development (or refamiliarizing myself
      in the case of HTML and CSS). The prework was much more challenging than those
      from the application process and in the end I feel they were designed to 
      introduce all of us to the concept on "learning how to learn". It may not
      sound like that big of a deal, but web development and technology in general
      is in a constant state of Kaizen (or continuous improvement, I can thank
      Toyota Motor Manufacturing for knowing that one) and requires developers to
      always be searching for or creating new and easier ways to perform the task
      at hand.
      </p>

      <p>
      I'll cover what my first week was like in my next post. It would be putting
      it <i>very</i> lightly to say that the pre-work was designed so we could all
      "hit the ground running" the first week, but more on that next time!
      </p>
    </div>

  </div>
</template>

<script>
  export default {
    name: 'postStartBootcamp'
  }
</script>

<style scoped>
  .date {
    color: #777;
  }
</style>


// WEBPACK FOOTER //
// src/components/posts/2017-09-23-Start-of-Bootcamp.vue